import {
  CircularProgress,
  Container,
  Divider,
  Grid2 as Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { Checkbox, Input, MaskedTextBox } from "@progress/kendo-react-inputs";
import {
  Card,
  CardActions,
  CardBody,
  CardHeader,
} from "@progress/kendo-react-layout";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import KvkkApproval from "../../components/kvkk/KvkkApproval";
import { CommonDropDownList as DropDownList } from "../../components/sys-common/CommonDropDownList";
import CommonMultiSelect from "../../components/sys-common/CommonMultiSelect";
import DateSelect from "../../components/sys-common/DateSelect";
import { generateTimeBasedId } from "../../helpers/utils";
import { useAppSelector } from "../../hooks/useAppSelector";
import CandidateService from "../../services/CandidateService";
import KvkkService from "../../services/KvkkService";
import { getKeyValueFromEvent } from "../../utils/getKeyValueFromEvent";
import CandidateStatusForm from "./CandidateStatusForm";
import GreetingModal from "./GreetingModal";
import NotApprovedWarning from "./NotApprovedWarning";
import JobApplicationPreview from "./Preview";
import SmsVerification from "./SmsVerification";

const handlePreventNumberKeyDown = (e) => {
  const key = e.nativeEvent?.key || e.key;
  if (/\d/.test(key)) {
    e.preventDefault();
  }
};
const initialFormData = {
  ad: "",
  soyad: "",
  cinsiyet: "",
  doguM_TARIHI: null,
  ceP_TEL_NO: "05",
  il: "SAKARYA",
  ilce: "",
  aciK_ADRES: "",
  askerlik: "",
  gEhliyet: "", // Yeni alan: G sınıfı ehliyet
  mezuniyet: "",
  bolum: "",
  sertifikalar: "",
  vardiyalI_CALISIR: "",
  akrabasI_VAR: "",
  akrabA_YAKINLIK: "",
  yuksektE_CALISIR: "",
  kvkkOnay: false,
  acikRizaOnay: false,
  deneyimler: [{}, {}],
};
const JobApplicationForm = (props) => {
  const { candidateId } = props;
  const { isAuthenticated } = useAppSelector((s) => s.auth);
  const phoneInputRef = React.useRef(null);
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [openSms, setOpenSms] = React.useState(false);
  const matche540 = useMediaQuery("(max-width:540px)");
  const [greetingModalOpen, setGreetingModalOpen] = React.useState(false);
  const [openNotApprovedWarning, setOpenNotApprovedWarning] =
    React.useState(false);
  const [o1, setO1] = React.useState();
  const [o2, setO2] = React.useState();
  const { t } = useTranslation();
  const id = React.useMemo(() => generateTimeBasedId(), []);
  const handleOpenSms = () => setOpenSms(!openSms);
  const handleOpenNotApprovedWarning = () =>
    setOpenNotApprovedWarning(!openNotApprovedWarning);
  const handleOpenGreetingModal = () =>
    setGreetingModalOpen(!greetingModalOpen);
  React.useEffect(() => {
    KvkkService.getLastOne("BILGILERIN_DOGURULUGUNU_KABUL_EDIYORUM")
      .then((result) => setO1(result.data[0]))
      .finally(() => setLoading(false));
    KvkkService.getLastOne("BILGERIN_DOGURULUGU_KABUL_VE_SONUCLAR")
      .then((result) => setO2(result.data[0]))
      .finally(() => setLoading(false));
  }, []);
  const yesNoData = React.useMemo(
    () => t("yes_no_data", { returnObjects: true }),
    [t]
  );
  const genderData = React.useMemo(
    () => t("gender_data", { returnObjects: true }),
    [t]
  );
  const militaryStatusData = React.useMemo(
    () => t("military_status_data", { returnObjects: true }),
    [t]
  );
  const educationLevelData = React.useMemo(
    () => t("education_level_data", { returnObjects: true }),
    [t]
  );
  const sakaryaIlceler = t("SAKARYA_ILCELER_DATA", { returnObjects: true });
  const [formData, setFormData] = useState(() => {
    return initialFormData;
  });
  useEffect(() => {
    if (candidateId !== "new") {
      setLoading(true);
      CandidateService.get(candidateId)
        .then((result) => setFormData(result.data))
        .finally(() => setLoading(false));
    }
  }, [candidateId]);

  const handleChange = (event) => {
    let [name, value] = getKeyValueFromEvent(event);
    setFormData((prevData) => {
      switch (name) {
        case "ad":
          if (value) {
            value = value
              .replace("i", "İ")
              .toUpperCase()
              .replace(/[^A-ZÇĞİÖŞÜ ]/g, "");
          }
          break;
        case "soyad":
          if (value)
            value = value
              .replace("i", "İ")
              .toUpperCase()
              .replace(/[^A-ZÇĞİÖŞÜ ]/g, "");
          break;
        case "akrabasI_VAR":
          if (value === "HAYIR") {
            delete prevData.akrabA_YAKINLIK;
          }
          break;
        case "aciK_ADRES":
          if (value) value = value.replace("i", "İ").toUpperCase();
          break;
        case "sertifikalar":
          if (value) value = value.replace("i", "İ").toUpperCase();
          break;
        case "bolum":
          if (value) value = value.replace("i", "İ").toUpperCase();
          break;
        case "cinsiyet":
          if (value === "KADIN") {
            delete prevData.askerlik;
          }
          break;
        case "ceP_TEL_NO":
          if (value?.length <= 2) {
            value = "05";
            // phoneInputRef.current.setSelectionRange(2, 2);
          } else {
            value = "05" + value.slice(2);
            //  phoneInputRef.current.setSelectionRange(2, 2);
          }
          break;
        case "gEhliyet":
          if (value === "HAYIR") {
            //
          }
          break;
        default:
          break;
      }
      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const handleChangeDeneyim = (i) => (event) => {
    let [name, value] = getKeyValueFromEvent(event);
    setFormData((prevData) => {
      switch (name) {
        case "akrabasI_VAR":
          if (value === "HAYIR") {
            delete prevData.akrabA_YAKINLIK;
          }
          break;
        case "soN_IS_YAPILAN_IS":
          if (value) {
            value = value.replace("i", "İ").toUpperCase();
          }
          break;
        case "cinsiyet":
          if (value === "KADIN") {
            delete prevData.askerlik;
          }
          break;
        case "soN_IS_AYRILMA_NEDEN":
          if (value) {
            value = value.replace("i", "İ").toUpperCase();
          }
          break;
        case "soN_IS_FIRMA":
          if (value) {
            value = value.replace("i", "İ").toUpperCase();
          }
          break;
        case "gEhliyet":
          if (value === "HAYIR") {
            //
          }
          break;
        default:
          break;
      }
      const deneyimler = formData.deneyimler.map((d, index) =>
        index === i ? { ...d, [name]: value } : d
      );
      return {
        ...prevData,
        deneyimler,
      };
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!formData.acikRizaOnay) return handleOpenNotApprovedWarning();
    CandidateService.validate({
      ...formData,
      ceP_TEL_NO: formData.ceP_TEL_NO?.replaceAll(" ", ""),
    })
      .then(handleOpenSms)
      .catch(() => {});
  };
  const handleInsert = () => {
    try {
      toast.promise(
        CandidateService.insert({
          ...formData,
          ceP_TEL_NO: formData.ceP_TEL_NO?.replaceAll(" ", ""),
        }).then((result) => {
          setFormData(result.data);
          setSuccess(true);
          setGreetingModalOpen(true);
        }),
        {
          pending: "Başvuru yapılıyor...",
          error: "Bir sorun ile karşılaşıldı",
          success: "Başvurunuz tamamlanmıştır.",
        }
      );
    } catch (error) {
      console.error(error);
    }
  };
  if (success || candidateId !== "new")
    return (
      <>
        {loading && (
          <Grid size={12} justifySelf="center">
            <Loader type="pulsing" />
          </Grid>
        )}
        <GreetingModal
          open={greetingModalOpen}
          onClose={handleOpenGreetingModal}
        />
        <Container maxWidth="md">
          <Grid container spacing={1}>
            <Grid size={{ xs: 12 }}>
              <JobApplicationPreview data={formData} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              {isAuthenticated && <CandidateStatusForm formData={formData} />}
            </Grid>
          </Grid>
        </Container>
      </>
    );

  return (
    <Container maxWidth="md">
      <form onSubmit={handleSubmit} style={{ padding: "16px" }}>
        <Card>
          <CardHeader>
            <h4 style={{ textAlign: "center" }}>{t("jobApplication.title")}</h4>
          </CardHeader>
          <CardBody>
            {loading && (
              <Grid size={12} justifySelf="center">
                <Loader type="pulsing" />
              </Grid>
            )}
            <Grid container spacing={2}>
              <Grid size={12}>
                <Divider>
                  <h5>{t("jobApplication.preview.generalInfo")}</h5>
                </Divider>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Input
                  name="ad"
                  label={t("jobApplication.personalInfo.name")}
                  value={formData.ad}
                  onChange={handleChange}
                  onKeyDown={handlePreventNumberKeyDown}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Input
                  name="soyad"
                  label={t("jobApplication.personalInfo.lastname")}
                  value={formData.soyad}
                  onChange={handleChange}
                  onKeyDown={handlePreventNumberKeyDown}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <DropDownList
                  name="cinsiyet"
                  label={t("jobApplication.personalInfo.gender")}
                  data={genderData}
                  defaultItem={{ text: t("choose"), value: null }}
                  textField="text"
                  dataItemKey="value"
                  value={genderData.find((x) => x.value === formData.cinsiyet)}
                  onChange={handleChange}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <DateSelect
                  name="doguM_TARIHI"
                  label={t("jobApplication.personalInfo.birthDate")}
                  value={formData.doguM_TARIHI}
                  onChange={(date) => {
                    setFormData({ ...formData, doguM_TARIHI: date });
                  }}
                  required={true}
                  maxDate={
                    new Date(
                      new Date().setFullYear(new Date().getFullYear() - 18)
                    )
                  } // En az 18 yaş
                  startYear={1950}
                  isDayVisible={true}
                  validationMessage={t("jobApplication.age_warning")}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Input
                  name="il"
                  label={t("jobApplication.address.city")}
                  value={formData.il}
                  required={true}
                  style={{ width: "100%" }}
                  readOnly
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <DropDownList
                  name="ilce"
                  label={t("jobApplication.address.district")}
                  data={sakaryaIlceler}
                  textField="text"
                  dataItemKey="value"
                  value={sakaryaIlceler.find((x) => x.value === formData.ilce)}
                  onChange={handleChange}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  fullWidth
                  multiline
                  name="aciK_ADRES"
                  label={t("jobApplication.address.fullAddress")}
                  value={formData.aciK_ADRES}
                  onChange={handleChange}
                  rows={4}
                  required={true}
                  variant="standard"
                />
              </Grid>
              <Grid size={12}>
                <Divider>
                  <h5>{t("jobApplication.preview.personalInfo")}</h5>
                </Divider>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <MaskedTextBox
                  mask="0500 000 00 00"
                  name="ceP_TEL_NO"
                  label={t("jobApplication.personalInfo.phone")}
                  value={formData.ceP_TEL_NO}
                  onChange={handleChange}
                  ref={phoneInputRef}
                  required={true}
                  maxLength={14}
                  style={{ width: "100%" }}
                />
              </Grid>
              {formData.cinsiyet === "ERKEK" && (
                <Grid size={{ xs: 12, md: 6 }}>
                  <DropDownList
                    name="askerlik"
                    label={t("jobApplication.military.status")}
                    data={militaryStatusData}
                    textField="text"
                    dataItemKey="value"
                    value={militaryStatusData.find(
                      (x) => x.value === formData.askerlik
                    )}
                    onChange={handleChange}
                    required={true}
                    style={{ width: "100%" }}
                  />
                </Grid>
              )}
              <Grid size={{ xs: 12, md: 6 }}>
                <DropDownList
                  name="g_LICENSE"
                  label={t("jobApplication.g_class")}
                  data={yesNoData}
                  textField="text"
                  dataItemKey="value"
                  value={yesNoData.find((x) => x.value === formData.g_LICENSE)}
                  onChange={handleChange}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <DropDownList
                  name="mezuniyet"
                  label={t("jobApplication.education.level")}
                  data={educationLevelData}
                  textField="text"
                  dataItemKey="value"
                  value={educationLevelData.find(
                    (x) => x.value === formData.mezuniyet
                  )}
                  onChange={handleChange}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={12}>
                <Input
                  name="bolum"
                  label={t("jobApplication.education.department")}
                  value={formData.bolum}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  fullWidth
                  name="sertifikalar"
                  label={t("jobApplication.certificates.title")}
                  value={formData.sertifikalar}
                  onChange={handleChange}
                  rows={3}
                  multiline
                  variant="standard"
                />
              </Grid>
              {formData.deneyimler.map((deneyim, i) => (
                <Grid container key={i}>
                  <Grid size={12}>
                    <Divider>
                      <h5>
                        {i === 0
                          ? t("jobApplication.lastJob.title")
                          : t("jobApplication.lastJob.title1")}
                      </h5>
                    </Divider>
                    {i === 1 &&
                      (matche540 ? (
                        <Typography textAlign="center" variant="caption">
                          (Lütfen en uzun süreli çalıştığınız iş deneyimini
                          paylaşınız)
                        </Typography>
                      ) : (
                        <Divider>
                          <Typography textAlign="center" variant="caption">
                            (Lütfen en uzun süreli çalıştığınız iş deneyimini
                            paylaşınız)
                          </Typography>
                        </Divider>
                      ))}
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Input
                      name="soN_IS_FIRMA"
                      label={t("jobApplication.lastJob.company")}
                      value={deneyim.soN_IS_FIRMA}
                      onChange={handleChangeDeneyim(i)}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Input
                      name="soN_IS_YAPILAN_IS"
                      label={t("jobApplication.lastJob.position")}
                      value={deneyim.soN_IS_YAPILAN_IS}
                      onChange={handleChangeDeneyim(i)}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <DateSelect
                      name="soN_IS_BAS_TAR"
                      label={t("jobApplication.lastJob.startDate")}
                      value={deneyim.soN_IS_BAS_TAR}
                      onChange={(date) =>
                        setFormData({
                          ...formData,
                          deneyimler: formData.deneyimler.map((d, index) =>
                            index === i ? { ...d, soN_IS_BAS_TAR: date } : d
                          ),
                        })
                      }
                      required={true}
                      maxDate={deneyim.soN_IS_BIT_TAR}
                      validationMessage={t(
                        "jobApplication.validations.startDateBeforeEndDate"
                      )}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <DateSelect
                      name="soN_IS_BIT_TAR"
                      label={t("jobApplication.lastJob.endDate")}
                      value={deneyim.soN_IS_BIT_TAR}
                      onChange={(date) =>
                        setFormData({
                          ...formData,
                          deneyimler: formData.deneyimler.map((d, index) =>
                            index === i ? { ...d, soN_IS_BIT_TAR: date } : d
                          ),
                        })
                      }
                      required={true}
                      minDate={deneyim.soN_IS_BAS_TAR}
                      validationMessage={t(
                        "jobApplication.validations.endDateAfterStartDate"
                      )}
                    />
                  </Grid>
                  <Grid size={12}>
                    <Input
                      fullWidth
                      name="soN_IS_AYRILMA_NEDEN"
                      label={t("jobApplication.lastJob.reasonForLeaving")}
                      value={deneyim.soN_IS_AYRILMA_NEDEN}
                      onChange={handleChangeDeneyim(i)}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>
              ))}

              <Grid size={{ xs: 12, md: 6 }}>
                <CommonMultiSelect
                  name="bolumler"
                  label={t("jobApplication.department")}
                  fetchUrl={"/department/list"}
                  textField="dkN_DMY_BOLUM_ADI"
                  dataItemKey="dkN_DMY_BOLUM_KOD"
                  value={formData.bolumler || []}
                  onChange={handleChange}
                  required={true}
                  id="bolumler"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <DropDownList
                  name="vardiyalI_CALISIR"
                  label={t("jobApplication.workPreferences.canWorkShifts")}
                  data={yesNoData}
                  textField="text"
                  dataItemKey="value"
                  value={yesNoData.find(
                    (x) => x.value === formData.vardiyalI_CALISIR
                  )}
                  onChange={handleChange}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <DropDownList
                  name="yuksektE_CALISIR"
                  label={t("jobApplication.workPreferences.canWorkAtHeight")}
                  data={yesNoData}
                  textField="text"
                  dataItemKey="value"
                  value={yesNoData.find(
                    (x) => x.value === formData.yuksektE_CALISIR
                  )}
                  onChange={handleChange}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <DropDownList
                  name="akrabasI_VAR"
                  label={t("jobApplication.relatives.hasRelatives")}
                  data={yesNoData}
                  textField="text"
                  dataItemKey="value"
                  value={yesNoData.find(
                    (x) => x.value === formData.akrabasI_VAR
                  )}
                  onChange={handleChange}
                  required={true}
                  style={{ width: "100%" }}
                />
              </Grid>
              {formData.akrabasI_VAR === "EVET" && (
                <Grid size={12}>
                  <Input
                    fullWidth
                    name="akrabA_YAKINLIK"
                    label={t("jobApplication.relatives.relation")}
                    value={formData.akrabA_YAKINLIK}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                    required
                  />
                </Grid>
              )}
              <Grid size={{ xs: 12 }}>
                <KvkkApproval
                  onSubmit={(checked) =>
                    setFormData({ ...formData, kvkkOnay: checked })
                  }
                  checkboxLabel="İşe Alım Süreçlerine Yönelik Aydınlatma Metni‘nde belirtilen hususları okudum ve anladım."
                  id="DAIKIN_IS_ORTAKLIGI_AYDINLATMA_METNI"
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <KvkkApproval
                  checkboxLabel="Paylaştığım kişisel verilerin Aydınlatma Metni’nde belirtilen hususlar dahilinde işlenmesine ve belirtilen amaçlarla aktarılmasına açık rıza veriyorum."
                  id="DAIKIN_IS_ORTAKLIGI_ACIK_RIZA_METNI"
                  onSubmit={(checked) =>
                    setFormData({ ...formData, acikRizaOnay: checked })
                  }
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Checkbox id="onay1" name="onay1" onChange={handleChange}>
                  <label
                    htmlFor={"onay1"}
                    className={"k-checkbox-label"}
                    style={{ display: "inline-block", marginLeft: "38px" }}
                  >
                    {o1 ? o1.iceriK_TR : <CircularProgress />}
                  </label>
                </Checkbox>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Checkbox id="onay2" name="onay2" onChange={handleChange}>
                  <label
                    htmlFor={"onay2"}
                    className={"k-checkbox-label"}
                    style={{ display: "inline-block", marginLeft: "38px" }}
                  >
                    {o2 ? o2.iceriK_TR : <CircularProgress />}
                  </label>
                </Checkbox>
              </Grid>
            </Grid>
          </CardBody>
          <CardActions>
            <Button
              themeColor="primary"
              disabled={
                !formData.kvkkOnay || !formData.onay1 || !formData.onay2
              }
              type="submit"
            >
              {t("jobApplication.common.submit")}
            </Button>
          </CardActions>
        </Card>
      </form>
      <SmsVerification
        data={formData}
        onVerified={handleInsert}
        onClose={handleOpenSms}
        smsId={id}
        open={openSms}
      />
      <NotApprovedWarning
        onClose={handleOpenNotApprovedWarning}
        open={openNotApprovedWarning}
      />
    </Container>
  );
};
export default JobApplicationForm;
